// This file is generated by a script and should not be modified directly.
const markdown: string =
  "The status of the offer (life cycle):\n\n- Active: The offer is available on the platform, and applications are open.\n- Filled: The offer has been filled and is no longer available.\n- Cancelled: The offer has been canceled and is no longer available.\n"
export default markdown
